/**
 * Best · Good · OK — `docs/new-request.md` §10.3, D5.
 *
 * A time is graded by the driving it **adds** to the person's day, because
 * that is the cost of the visit to everybody else on their calendar: a stop
 * that sits between two others a mile away adds five minutes, one across the
 * county adds forty. One definition, run by the server; the sheet shows the
 * grade it was sent and never works one out (rule 2).
 */
export const GRADES = ['best', 'good', 'ok'];
export const GRADE_LABELS = {
    best: 'Best',
    good: 'Good',
    ok: 'OK',
};
/** Protected both sides of a visit, on top of the drive (§10.2). */
export const MARGIN_MINUTES = 5;
/** Best adds at most this much driving; Good at most `GOOD_MINUTES`. */
export const BEST_MINUTES = 10;
export const GOOD_MINUTES = 20;
export function gradeFor(addedMinutes) {
    if (addedMinutes <= BEST_MINUTES)
        return 'best';
    if (addedMinutes <= GOOD_MINUTES)
        return 'good';
    return 'ok';
}
/** Best before Good before OK, for sorting. */
export const gradeRank = (grade) => GRADES.indexOf(grade);
/**
 * Up to the quarter hour: 9:58 → 10:00, and 10:00 stays 10:00. Starts land
 * on the quarter hour (§10.2); a block somebody drags snaps to five minutes
 * instead, which is the sheet's business and not this function's.
 */
export function ceil15(minutes) {
    return Math.ceil(minutes / 15) * 15;
}
//# sourceMappingURL=grade.js.map